import $ from "jquery"
import { trace } from "rytm-helpers"
import { windowUpdate } from "./../shared/common"
import ASwap from "./ASwap";
import Events from "./Events";
import Controller from "./Controller";
import routes from './routes';

class MainController {
  /**
  * @constructor
  **/
  constructor() {
    this.controllers = []; // tablica {id, controller}
  }

  init() {
    this.aswap = new ASwap();

    this.aswap.on(Events.NAV_REQUEST_URL, this.onRequestUrl.bind(this));
    this.aswap.on(Events.NAV_REQUEST_LOAD, this.onRequestLoad.bind(this));
    this.aswap.on(Events.NAV_REQUEST_LOADED, this.onRequestLoaded.bind(this));
    this.aswap.on(Events.NAV_VIEW_HIDE, this.onViewHide.bind(this));
    this.aswap.on(Events.NAV_VIEW_HIDDEN, this.onViewHidden.bind(this));
    this.aswap.on(Events.NAV_SWAP_START, this.onViewSwapStart.bind(this));
    this.aswap.on(Events.NAV_SWAP_COMPLETE, this.onViewSwapComplete.bind(this));
    this.aswap.on(Events.NAV_VIEW_SHOW, this.onViewShow.bind(this));
    this.aswap.on(Events.NAV_VIEW_SHOWN, this.onViewShown.bind(this));

    this.aswap.init();
    setTimeout(()=> {
      document.documentElement.classList.remove("index-loading");
    }, 200);

  }

  /**
  * go to URL
  * @param url {String}
  * @param noHistory {Boolean} - if the pushState should be skipped (default false)
  **/
  openURL(url, noHistory = false, useCache = true) {
    if (this.aswap) {
      this.aswap.openURL(url, noHistory, useCache)
    }
  }

  onRequestUrl(e) {
    document.documentElement.classList.add('aswap-in-progress')
    document.documentElement.classList.remove('mobile-menu-open')
    this.getActiveControlles().forEach( (c, index)=> {
      c.onRequestUrl(e);
    });
  }
  onRequestLoad(e) {
    document.documentElement.classList.add('js');
    document.documentElement.classList.add('request-loading');
    this.getActiveControlles().forEach( (c, index)=> {
      c.onRequestLoad(e);
    });
  }
  onRequestLoaded(e) {
    this.getControllersFromContainer(e.target.$freshContent).forEach( (c, index)=> {
      c.onRequestLoaded(e);
    });
    document.documentElement.classList.remove("request-loading");
  }
  onViewHide(e) {
    document.documentElement.classList.add('as-hide');
    this.getActiveControlles().forEach( (c, index)=> {
      // if view is not present in fresh content then call controller hide
      if (!c.getViewContainer(e.target.$freshContent).length) {
        c.onViewHide(e);
      }
    });
  }
  onViewHidden(e) {
    document.documentElement.classList.remove('as-hide');
    this.getActiveControlles().forEach( (c, index)=> {
      // if view is not present in fresh content then call controller hidden
      if (!c.getViewContainer(e.target.$freshContent).length) {
        c.onViewHidden(e);
      }
    });
  }
  onViewSwapStart(e) {
    this.getControllersFromContainer(e.target.$freshContent).forEach( (c, index)=> {
      c.onViewSwapStart(e);
    });
  }
  onViewSwapComplete(e) {
    // SIV update
    windowUpdate();
    this.getControllersFromContainer(e.target.$freshContent).forEach( (c, index)=> {
      c.onViewSwapComplete(e);
    });
  }
  onViewShow(e) {
    document.documentElement.classList.add('as-show');
    this.getControllersFromContainer(e.target.$freshContent).forEach( (c, index)=> {
      c.onViewShow(e);
    });
  }
  onViewShown(e) {
    document.documentElement.classList.add('as-show');
    this.getControllersFromContainer(e.target.$freshContent).forEach( (c, index)=> {
      c.onViewShown(e);
    });
    document.documentElement.classList.remove('aswap-in-progress');
  }


  /**
  * get an array of all active controllers
  * @returns {Array}
  **/
  getActiveControlles() {
    let arr = [];
    this.controllers.forEach( (obj, index)=> {
      if (obj.controller.active) {
        arr.push(obj.controller);
      }
    });
    return arr;
  }
  /**
  * get controllers from container based on view's included in the container
  * @param {jQuery} $container
  * @returns {Array}
  **/
  getControllersFromContainer($container) {
    let arr = [];
    $container.find("*[data-as-view]").each( (index, el)=> {
      let name = $(el).data("as-view");
      let id = $(el).data("as-id");
      if (!id) {
        id = name;
      }
      let c = this.getController(name, id);
      if (c) {
        arr.push(c);
      }
    });
    return arr;
  }
  /**
  * get controller (check store if not found create new controller)
  * @param {String} name
  * @param {Int|String} id - unique ID
  * @returns {EventDispatcher}
  **/
  getController(name, id) {
    let c = this.getStoredController(id);
    if (!c) {
      c = this.createController(name, id);
      if (c) {
        this.storeController(id, c);
      }
    }
    return c;
  }

  /**
  * create controller
  * @param {String} name - controller type name
  * @param {Int|String} id - unique ID
  * @returns {EventDispatcher}
  **/
  createController(name, id) {
    let c = false;
    if (routes[name]) {
      if (routes[name].controller) {
        c = new routes[name]["controller"](id);
        c.name = name;
        if (routes[name].view) {
          c.setView( new routes[name]["view"](id) );
        }
      }
    }
    return c;
  }
  /**
  * store controller
  * @param {Int|String} id - unique controller ID
  * @param {EventDispatcher} controller
  **/
  storeController(id, controller) {
    this.controllers.push({id, controller})
  }
  /**
  * get controller from store
  * @param {Int|String} id
  * @returns {EventDispatcher}
  **/
  getStoredController(id) {
    let controller = false;
    this.controllers.forEach( (r, index)=> {
      if (r.id == id) {
        controller = r.controller;
      }
    });
    return controller;
  }


}
const mainController = new MainController();
export default mainController;
